import { format, parse, getHours } from 'date-fns';
import { padStart } from 'lodash';
import queryString from 'query-string';

const products = JSON.parse(document.documentElement.dataset.products);

export const getProductName = (sku, systemType) => {
  const product = getProduct(sku, systemType);
  return product.name;
};

export const getProduct = (sku, systemType) => {
  return products[systemType].find(product => product.sku === sku);
};

export const getUrgentSku = (systemType) => {
  const product = products[systemType].find(product => product.type === "urgent");
  return product.sku;
}

export const getStandardSku = (systemType) => {
  const product = products[systemType].find(product => product.type === "standard");
  return product.sku;
}

export const getDateTime = (date, time) => (
  `${getDate(date)} between ${getTimeWindow(time)}`
);

export const getDate = (date) => (
  `${format(parse(date, 'yyyy-MM-dd', new Date()), 'EEEE, MMM d')}`
)

export const getTimeWindow = (time) => {
  const startTime = getHours(parse(time, 'HH:mm', new Date()));

  return formattedTimeWindow(startTime);
}

export const formatCurrency = (currencySymbol, fullAmount) => {
  fullAmount = String(fullAmount);
  const cents = formatCents(fullAmount.slice(-2));
  let dollars;

  if (isNegative(fullAmount)) {
    dollars = formatDollars(fullAmount.slice(1, -2));
    return '-' + currencySymbol + dollars + '.' + cents;
  }

  dollars = formatDollars(fullAmount.slice(0, -2));
  return currencySymbol + dollars + '.' + cents;
}

export const isStandard = (sku, systemType) => {
  const product = getProduct(sku, systemType);
  return product.type == "standard";
}

const formatCents = amount => {
  while (amount.length < 2 ) {
    amount = '0' + amount
  }

  return amount;
}

const formatDollars = amount => {
  while (amount.length < 1 ) {
    amount = '0' + amount
  }

  return amount;
}

const isNegative = amount => {
  return parseInt(amount) < 0;
}

const formattedHour = (value) => {
  const hour = value > 12 ? (value - 12) : value;
  const period = value >= 12 ? 'pm' : 'am';

  return `${hour}:00${period}`;
}

export const formattedTimeWindow = (startHour) => {
  const endHour = startHour + TIME_WINDOW_HOURS;

  return `${formattedHour(startHour)} - ${formattedHour(endHour)}`;
}

export const generateTimeSlots = (weekDay = 2) => (
  TIME_WINDOW_STARTS_CONFIG[weekDay].map((startHour) => {
    const value = `${padStart(startHour, 2, '0')}:00`;
    const name = formattedTimeWindow(startHour);
    return {
      startHour,
      value,
      name,
    }
  }));

export const TIME_WINDOW_HOURS = 4;
export const TIME_WINDOW_STARTS_CONFIG = [
  [], // no time frames on Sunday
  [12, 16],
  [8, 12, 16],
  [8, 12, 16],
  [8, 12, 16],
  [8, 12, 16],
  [8],
];

export const getSystemType = (systemType) => {
  if (products[systemType] && products[systemType].length > 0) { return systemType; }

  return "generic";
}

export const paramFromQueryString = (searchString, paramName) => {
  return queryString.parse(searchString)[paramName] || '';
}
